// extracted by mini-css-extract-plugin
export var productImage = "_ri-1";
export var viewLink = "_ri-2";
export var wishlistItem = "_ri-0";